export enum EmailReportTemplateEnum {
  DailyGroupsWorkloadReport = 'DailyGroupsWorkloadReport',
  DailyBranchesWorkloadReport = 'DailyBranchesWorkloadReport',
  DailyAgentWorkloadReport = 'DailyAgentWorkloadReport',
  InactiveAgentReport = 'InactiveAgentReport',
  TeamsAgentWorkloadReport = 'TeamsAgentWorkloadReport',
  TeamsWorkloadReport = 'TeamsWorkloadReport',
  RoutePlanningStatus = 'RoutePlanningStatus',
  DailyCustomRouteOrdersReport = 'DailyCustomRouteOrdersReport'
}
